var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"img-border",staticClass:"top-img-class",style:({ height: _vm.borderHeight })},[_c('img',{style:({
      width: _vm.imgWidth,
      height: _vm.imgHeight,
      'margin-top': _vm.marginTop,
      'margin-left': _vm.marginLeft,
    }),attrs:{"src":_vm.theSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }